import type { ErrorItem } from "@auth0/auth0-acul-react/types";
import { Alert, Button } from "@prophero-ds/cx-react";

import { useSdkErrorMessage } from "@/hooks/useSdkErrorMessage";

interface GeneralErrorAlertProps {
  errors: ErrorItem[];
  hasError: boolean;
  onDismiss: (id: string) => void;
  fallbackMessage: string;
  dismissLabel: string;
}

function GeneralErrorAlert({
  errors,
  hasError,
  onDismiss,
  fallbackMessage,
  dismissLabel,
}: GeneralErrorAlertProps) {
  const getErrorMessage = useSdkErrorMessage();

  if (!hasError || errors.length === 0) return null;

  return (
    <div className="flex w-full flex-col gap-2">
      {errors.map((error) => (
        <Alert
          key={error.id}
          variant="danger"
          paragraph={getErrorMessage(error) ?? fallbackMessage}
          action={
            <Button
              type="button"
              id={`error-dismiss-${error.id}`}
              variant="ghost"
              tone="neutral"
              size="small"
              onClick={() => onDismiss(error.id)}
            >
              {dismissLabel}
            </Button>
          }
        />
      ))}
    </div>
  );
}

export default GeneralErrorAlert;
